import Photo from './Photo';
import SmartLink from './SmartLink';
import LinkText from './LinkText';
import { Horizon, Peeks, splitArt } from './Art';

function Way({ way }) {
  return (
    <li className="way">
      <SmartLink url={way.url} className="way-art" aria-label={way.title}>
        <Photo src={way.image} alt={way.title} fallback />
      </SmartLink>
      <div className="way-body">
        <h4 className="display display--s">{way.title}</h4>
        {way.desc.map((p, i) => <p key={i}><LinkText text={p} /></p>)}
        {way.url && <SmartLink url={way.url} className="btn btn--light">{way.button}</SmartLink>}
      </div>
    </li>
  );
}

export default function Support({ heading, support, art }) {
  const { subheading, mission, extra, ways, thanks } = support;
  const { peeks, horizon } = splitArt(art);
  if (!mission.length && !ways.length) return null;
  return (
    <section id="support" className={`sec sec--cobalt support ${horizon ? 'sec--horizon' : ''}`} aria-labelledby="support-title">
      <div className="support-tiles" aria-hidden="true" />
      <Peeks items={peeks} />
      <div className="wrap">
        <div className="split support-grid">
          <div className="support-mission">
            <h2 id="support-title" className="display">{heading}</h2>
            {subheading && <h3 className="display display--s">{subheading}</h3>}
            {mission.map((p, i) => <p key={i} className="lede"><LinkText text={p} /></p>)}
            {extra.map((p, i) => <p key={`x${i}`}><LinkText text={p} /></p>)}
          </div>
          <ul className="ways">
            {ways.map((w) => <Way key={w.key} way={w} />)}
          </ul>
        </div>
        {thanks && <p className="thanks display display--m">{thanks}</p>}
      </div>
      {horizon && <Horizon name={horizon.name} />}
    </section>
  );
}
